import React, { useState, useEffect } from 'react';
import './SupportDashboard.css';

const SupportDashboard = () => {
  const [stats, setStats] = useState({
    pending_tickets: 0,
    in_progress_tickets: 0,
    resolved_today: 0,
    total_feedbacks: 0,
    avg_response_time: 0,
    satisfaction_rate: 0
  });
  const [recentTickets, setRecentTickets] = useState([]);
  const [recentFeedbacks, setRecentFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadSupportStats();
    loadRecentTickets();
    loadRecentFeedbacks();
    // 每30秒刷新一次数据
    const interval = setInterval(() => {
      loadSupportStats();
      loadRecentTickets();
      loadRecentFeedbacks();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadSupportStats = async () => {
    try {
      // 使用模拟数据
      setStats({
        pending_tickets: 8,
        in_progress_tickets: 5,
        resolved_today: 12,
        total_feedbacks: 156,
        avg_response_time: 1.5,
        satisfaction_rate: 4.8
      });
      setError('');
    } catch (err) {
      setError('网络错误，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const loadRecentTickets = () => {
    // 使用模拟工单数据
    setRecentTickets([
      {
        id: 'TK001',
        user: '张三',
        subject: '积分扣除问题',
        status: 'pending',
        created_at: '2025-01-27 10:30',
        priority: 'high'
      },
      {
        id: 'TK002',
        user: '李四',
        subject: '无法登录账号',
        status: 'in_progress',
        created_at: '2025-01-27 09:15',
        priority: 'medium'
      },
      {
        id: 'TK003',
        user: '王五',
        subject: '功能使用咨询',
        status: 'pending',
        created_at: '2025-01-27 08:45',
        priority: 'low'
      }
    ]);
  };
  
  const loadRecentFeedbacks = () => {
    // 使用模拟反馈数据
    setRecentFeedbacks([
      {
        id: 1,
        user: '赵六',
        score: 5,
        comment: '新功能很实用，界面也很美观',
        created_at: '2025-01-27 09:00'
      },
      {
        id: 2,
        user: '孙七',
        score: 2,
        comment: '支付功能有问题，希望尽快修复',
        created_at: '2025-01-27 08:30'
      },
      {
        id: 3,
        user: '周八',
        score: 4,
        comment: '整体体验不错，希望增加夜间模式',
        created_at: '2025-01-27 08:00'
      }
    ]);
  };

  const StatCard = ({ title, value, icon, color, loading: isLoading }) => (
    <div className="stat-card">
      {icon && <div className="stat-icon" style={{ backgroundColor: color }}>
        {icon}
      </div>}
      <div className="stat-content">
        <div className="stat-value">
          {isLoading ? '...' : value}
        </div>
        <div className="stat-title">{title}</div>
      </div>
    </div>
  );

  const TicketCard = ({ ticket }) => (
    <div className={`ticket-card ${ticket.status}`}>
      <div className="ticket-header">
        <div className="ticket-id">{ticket.id}</div>
        <div className={`priority-badge ${ticket.priority}`}>
          {ticket.priority === 'high' ? '高' : ticket.priority === 'medium' ? '中' : '低'}
        </div>
      </div>
      <div className="ticket-content">
        <div className="ticket-subject">{ticket.subject}</div>
        <div className="ticket-user">{ticket.user}</div>
        <div className="ticket-time">{ticket.created_at}</div>
      </div>
      <div className="ticket-actions">
        <button className="btn btn-sm btn-primary">处理</button>
      </div>
    </div>
  );
  
  const FeedbackCard = ({ feedback }) => (
    <div className="feedback-card">
      <div className="feedback-header">
        <div className="feedback-user">{feedback.user}</div>
        <div className="feedback-score">
          {'★'.repeat(feedback.score)}{'☆'.repeat(5 - feedback.score)}
        </div>
      </div>
      <div className="feedback-comment">{feedback.comment}</div>
      <div className="feedback-time">{feedback.created_at}</div>
    </div>
  );

  return (
    <div className="support-dashboard">
      <div className="dashboard-header">
        <div className="header-left">
          <h2>客服工作台</h2>
          <p>高效处理用户问题</p>
        </div>
        <div className="header-right">
          <button className="refresh-btn" onClick={loadSupportStats}>
            刷新
          </button>
        </div>
      </div>

      {error && (
        <div className="error-banner">
          <span>{error}</span>
          <button onClick={loadSupportStats}>重试</button>
        </div>
      )}

      {/* 核心指标 */}
      <div className="stats-grid">
        <StatCard
          title="待处理工单"
          value={stats.pending_tickets}
          icon=""
          color="#e53e3e"
          loading={loading}
        />
        <StatCard
          title="处理中"
          value={stats.in_progress_tickets}
          icon=""
          color="#ed8936"
          loading={loading}
        />
        <StatCard
          title="今日已解决"
          value={stats.resolved_today}
          icon=""
          color="#48bb78"
          loading={loading}
        />
        <StatCard
          title="用户反馈"
          value={stats.total_feedbacks}
          icon=""
          color="#4299e1"
          loading={loading}
        />
        <StatCard
          title="平均响应"
          value={`${stats.avg_response_time}h`}
          icon=""
          color="#9f7aea"
          loading={loading}
        />
        <StatCard
          title="满意度"
          value={`${stats.satisfaction_rate}/5`}
          icon=""
          color="#f6ad55"
          loading={loading}
        />
      </div>

      {/* 两栏布局：工单和反馈 */}
      <div className="dashboard-grid">
        {/* 最近工单 */}
        <div className="recent-section">
          <div className="section-header">
            <h3>最近工单</h3>
            <button className="btn btn-primary" onClick={() => {
              const event = new CustomEvent('adminSwitchView', { detail: 'tickets' });
              window.dispatchEvent(event);
            }}>查看全部</button>
          </div>
          <div className="cards-list">
            {recentTickets.map(ticket => (
              <TicketCard key={ticket.id} ticket={ticket} />
            ))}
          </div>
        </div>

        {/* 最近反馈 */}
        <div className="recent-section">
          <div className="section-header">
            <h3>最近反馈</h3>
            <button className="btn btn-primary" onClick={() => {
              const event = new CustomEvent('adminSwitchView', { detail: 'feedback' });
              window.dispatchEvent(event);
            }}>查看全部</button>
          </div>
          <div className="cards-list">
            {recentFeedbacks.map(feedback => (
              <FeedbackCard key={feedback.id} feedback={feedback} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportDashboard;
